var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAnnotateArea = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 1H6v1h4zm2 3H4v8h8zM3 3v10h10V3zm11 11v-2h1v3h-3v-1zm1-8h-1v4h1zM1 6h1v4H1zm5 8h4v1H6zm6-12h2v2h1V1h-3zM2 2v2H1V1h3v1zm2 12H2v-2H1v3h3z",
  clipRule: "evenodd"
})));
export default SvgAnnotateArea;